import React, { useEffect } from 'react';
// import { Link } from 'react-router-dom';
import HeroSection from './HeroSection';
// import TrustedBySection from './TrustedBySection';
import '../styles/HomePage.css';
import OurServicesSection from './OurServices';
import NextGenCloud from './NextGenCloud';
import IndustriesSection from './IndustriesSection';
import TechStackSection from './industries/TechStackSection';
import WhyChooseReventLabsSection from './WhyChooseReventLabsSection';
// import CaseStudiesSection from './CaseStudiesSection';
// import ScrollPinSection from './ScrollPinSection';


const HomePage: React.FC = () => {
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <HeroSection />
      {/* <TrustedBySection /> */}
      <div className="home-page-h">
        <OurServicesSection />
        <NextGenCloud />
        <IndustriesSection />

        <TechStackSection
          title={`An Engineering Stack Built Around Your Security Needs`}
          description={`ReventLabs ensures your infrastructure isn't just production-ready — it's built to meet every compliance standard your business requires`}
          items={[]}
        />
        
        {/* New Why Choose ReventLabs Section */}
        <WhyChooseReventLabsSection />
        {/* <CaseStudiesSection /> */}
        {/* <ScrollPinSection /> */}
        
      </div>
    </>
  );
};

export default HomePage;